import ClientParseFlightIdResponse from '../interfaces/client/ParseFlightIdResponse'

import constants from '../config/constants'

import { dateToFrontEndFormat } from './dates'

export default (id: string): ClientParseFlightIdResponse => {
  if (id.length < 19 || id.length > 20) {
    throw new Error(`The flight ID ${id} has the wrong format.`)
  }

  const date = dateToFrontEndFormat(
    id.substring(6, 14),
    constants.fromFlightIdDateFormat
  )

  return {
    departure: id.substring(0, 3),
    arrival: id.substring(3, 6),
    date,
    number: id.substring(14),
  }
}
